import VueRouter from 'vue-router';
import Mint from './pages/mint/index.vue';

const router = new VueRouter({
  routes: [{
    path: '/', component: Mint
  }]
})

export default router;